/* Cravinbyandy — reusable photo gallery lightbox ("VIEW PHOTOS" / About Cafe blocks).
   Adapted from catering-services-modal.js: open/close, focus trap, ESC/overlay/X
   close, thumbnail click swaps the main image with the same crossfade. This gallery
   has no service rail to click through instead, so prev/next arrow buttons and
   ArrowLeft/ArrowRight keyboard nav are added on top of the shared pattern. */
(function () {
  function initSection(root) {
    var modal = root.querySelector('.pgm');
    if (!modal || modal.dataset.pgmInit) return;
    modal.dataset.pgmInit = '1';

    var opener = root.querySelector('[data-gallery-open]');
    var closers = modal.querySelectorAll('[data-gallery-close]');
    var dialog = modal.querySelector('.pgm__dialog');
    var main = modal.querySelector('[data-gallery-main]');
    var prevBtn = modal.querySelector('[data-gallery-prev]');
    var nextBtn = modal.querySelector('[data-gallery-next]');
    var thumbs = Array.prototype.slice.call(modal.querySelectorAll('[data-gallery-thumb]'));
    if (!opener || !main || !thumbs.length) return;

    var index = 0;
    var lastFocus = null;
    // Track the intended src ourselves rather than reading main's DOM attribute —
    // during a fade, the attribute hasn't updated yet, so rapid clicks (prev/next
    // held down) would compare against a stale value and silently no-op.
    var currentSrc = main.getAttribute('src');
    var swapTimer = null;
    var swapHandler = null;

    function cancelPendingSwap() {
      if (swapTimer) { clearTimeout(swapTimer); swapTimer = null; }
      if (swapHandler) { main.removeEventListener('transitionend', swapHandler); swapHandler = null; }
    }

    function show(i) {
      index = (i + thumbs.length) % thumbs.length;
      var thumb = thumbs[index];
      var img = thumb.querySelector('img');
      thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === index); });
      // compare resolved URLs — main and thumb are served at different widths
      var target = thumb.getAttribute('data-gallery-full') || (img && (img.currentSrc || img.src));
      if (!target || target === currentSrc) return;
      currentSrc = target;
      cancelPendingSwap(); // supersede any fade still in flight from a prior rapid click
      main.style.opacity = '0';
      swapHandler = function () {
        cancelPendingSwap();
        main.src = target;
        main.alt = img ? img.alt : '';
        main.style.opacity = '';
      };
      main.addEventListener('transitionend', swapHandler);
      swapTimer = setTimeout(swapHandler, 220); // guard for transitions-off / reduced-motion
    }

    function open() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.documentElement.classList.add('pgm-open');
      show(0);
      if (dialog) dialog.focus();
    }

    function close() {
      modal.hidden = true;
      document.documentElement.classList.remove('pgm-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    opener.addEventListener('click', function (e) {
      e.preventDefault();
      open();
    });
    closers.forEach(function (c) { c.addEventListener('click', close); });
    if (prevBtn) prevBtn.addEventListener('click', function () { show(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(index + 1); });
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i); });
    });

    modal.addEventListener('keydown', onKeydown);
    document.addEventListener('keydown', onKeydown);
    function onKeydown(e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'ArrowLeft') { show(index - 1); return; }
      if (e.key === 'ArrowRight') { show(index + 1); return; }
      if (e.key === 'Tab' && dialog) {
        var f = dialog.querySelectorAll('button, [href], input, [tabindex]:not([tabindex="-1"])');
        var vis = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
        if (!vis.length) return;
        var first = vis[0], last = vis[vis.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
  }

  function initAll() {
    document.querySelectorAll('[data-gallery]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
